import baseIcon from '../base.mjs';

const SiCmake = baseIcon("CMake", "#064F8C", "M11.769.066L.067 23.206l12.76-10.843zM23.207 23.934L7.471 17.587 0 23.934zM24 23.736L12.298.463l1.719 19.24zM12.893 12.959l-5.025 4.298 5.62 2.248z");
const SiCmake$1 = SiCmake;

export { SiCmake$1 as default };
